import { Pipe, PipeTransform } from "@angular/core";
import { SOTService } from "../services";

/*
 * Formats a number to a Price with currency
*/
@Pipe({name: "price"})
export class SOTPricePipe implements PipeTransform {
    constructor(private _sotService: SOTService) {}
    /**
     * transform a number into a price string
     * default behavior 1.234 -> "1.23 €"
     * @param price numeric value to transform to a string
     * @param formatString formatString default "p c"
     *   p is the price
     *   c is currencysymbol
     *   + is a plusSign if positive
     */
  transform(price: number, formatString: string = "p c"): string {
    const plusSign = (price >= 0) ? "+" : "";
    return formatString
      .replace("+", plusSign)
      .replace("p", this._sotService.formatCurrency(price, false))
      .replace("c", this._sotService.GetSettings().currencySymbol);
  }
}
